function degrees(degrees, minutes, seconds) {
  return degrees + minutes / 60 + seconds / 3600;
}

export default degrees;
